import React from 'react';
import CustomMarker from '../CustomMarker';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {Overlay} from '@homeaway/react-google-maps';
import {MapHit} from '../../MapHit/MapHit';
import {useMapContext} from '../../../context/MapContext';

import './PriceMarker.less';
import {MAP_PIN_TYPES} from '../../../utils/markers';

const PriceMarker = (props) => {
    const {isSelected, label, status, infoWindowOptions, index} = props;
    const soldOut = status === 'sold_out';
    const loading = status === 'loading';
    const mapContext = useMapContext();

    const markerClasses = classNames('price-marker-anchor', {
        'price-marker-highlighted': isSelected,
        'price-marker-disabled': soldOut,
        'price-marker-loading': loading,
    });

    const loadingOverlay = `
            <div class="marker-loading-overlay">
                <ul aria-hidden class="marker-loading-overlay__ul">
                    <li class="marker-loading-overlay__li marker-loading-overlay__li--1"></li>
                    <li class="marker-loading-overlay__li marker-loading-overlay__li--2"></li>
                    <li class="marker-loading-overlay__li marker-loading-overlay__li--3"></li>
                    <li class="marker-loading-overlay__li marker-loading-overlay__li--4"></li>
                </ul>
            </div>
        `;

    const priceLabel = `<h5 class="price-marker-content-label">${label}</h5>`;

    const markerContent = `
            <div class="${markerClasses}">
                <div class="price-marker-content">${
                    loading ? loadingOverlay : priceLabel
                }</div>
            </div>
        `;

    const showMapOverlay = () => {
        if (mapContext.isMobile) {
            return isSelected && infoWindowOptions && infoWindowOptions.images;
        }
        return null;
    };

    const {
        pixelOffset,
        infoBoxClearance,
        detailPageUrl,
        bathrooms,
        bedrooms,
        sleeps,
        images,
        priceSummary,
    } = infoWindowOptions || {};
    const mapData = {
        detailPageUrl,
        pixelOffset,
        infoBoxClearance,
        bathrooms,
        bedrooms,
        sleeps,
        images,
        priceSummary,
    };

    const renderOverlayContent = () => {
        return showMapOverlay() ? (
            <Overlay
                pixelOffset={pixelOffset}
                infoBoxClearance={infoBoxClearance}
            >
                <MapHit infoWindowOptions={mapData} hitIndex={index} />
            </Overlay>
        ) : null;
    };

    return (
        <CustomMarker
            {...props}
            appName={mapContext.appName}
            className="price-marker"
            markerContent={markerContent}
            pinType={MAP_PIN_TYPES.PRICE}
        >
            {renderOverlayContent()}
        </CustomMarker>
    );
};

PriceMarker.propTypes = {
    id: PropTypes.string.isRequired,
    isHighlighted: PropTypes.bool,
    label: PropTypes.string,
    map: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    onClick: PropTypes.func,
    onHover: PropTypes.func,
    onHoverLeave: PropTypes.func,
    position: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
    }).isRequired,
};

export default PriceMarker;
